import VueRouter from 'vue-router';
import Cookies from 'js-cookie';
import routes from './routes';
import store from '../store';

const whiteList = ['/login', '/wechatlogin', '/findpassword', '/resetpassword', '/bindaccount']; // no redirect whitelist

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(async (to, from, next) => {
  // 添加缓存(取keep属性)
  if (to.meta.keep) {
    const includeList = store.state.vm.includeList;
    const isHas = includeList.includes(to.meta.keep);
    if (!isHas) {
      includeList.push(to.meta.keep);
      store.commit('INCLUDELIST', includeList);
    }
  }
  // 登录权限
  if (whiteList.includes(to.path)) {
    // 已经登录则跳转首页
    if (Cookies.get('token') && to.path === '/login') {
      next({ path: '/', replace: true });
    } else {
      next();
    }
    return;
  }
  // 验证是否登录
  if (Cookies.get('token')) {
    // if (!store.state.userInfo.userId) {
    //   await store.dispatch('LoginUserInfo');
    // }
    next();
    return;
  }
  // 以上都不满足，跳转登录页
  next({ path: '/login' });
});

// router.afterEach((to) => {
// });

export default router;
